export enum ScheduledAdditionalDataProp {
  CalendarEvents = 'calendarEvents',
}
